//#region Libraries
//#endregion
//#region Styles
import { Container, CardLinkWrapper, ResourceCardLinkItem } from "./styles";
import { TitleSection } from "components/styles";
//#endregion
//#region Components
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
//#endregion
//#region Utils
import { INFORMATION_LINKS, TOOLTIP_PROPS } from "./utils/constants";
import { userHasPermission } from "config/userPermissions";
import useDashboardContext from "routes/utils/context/useDashboardContext";
//#endregion


const ResourcesHome = () => {
    const { id: userRole } = useDashboardContext().user.role;
    return (
        <>
        <HelmetUTP title="Recursos"/>
        <Container>
            <TitleSection textAlign="center">¿Qué espacio deseas registrar?</TitleSection>
            <CardLinkWrapper>
                {INFORMATION_LINKS
                .filter(({ id: permission }) => userHasPermission(userRole, permission))
                .map((item, idx) => (
                    <ResourceCardLinkItem 
                        key={idx} 
                        variant="secondary" 
                        {...item}
                        tooltip={{
                            props: TOOLTIP_PROPS,
                            ...item.tooltip
                        }}/>
                ))}
            </CardLinkWrapper>
        </Container>
        </>
    );
}

export default ResourcesHome;